import './job-offer-card.scss';
import { sanitizeString } from '../../../assets/js/text-renderer';

const getCard = (data) => `
<article class="job-offer-card w-full">
  <div class="col-12 col-md-9">
    <header class="job-offer-card__title">
      <h4>${data.title}</h4>
      <span class="careers-position-${data.experience}">
        ${capitalizeText(data.experience)}
      </span>
    </header>
    <p>${data.description}</p>
    <div class="job-offer-card__benefits gap-2">
      ${getBenefit(data.benefits)}
    </div>
  </div>
  <a 
    class="job-offer-card__link col-12 col-md-3 text-start text-md-end" 
    href="/nosotros/careers/job/?cod=${data.slug}"
  >
    <span>${data.cta}</span>
    <i class="fal fa-long-arrow-right"></i>
  </a>
</article>
`;

const getBenefit = (benefits) => {
  return benefits.map(benefit => {
    let benefitHTML = '';
    switch (benefit) {
      case 'permanent':
        benefitHTML = `
          <img 
            class="job-offer-card__benefits-img" 
            src="/assets/iconos/contract-grey.svg" 
          />
          <span>Contrato indefinido</span>
        `;
        break;
      case 'fulltime':
        benefitHTML = `
          <img 
            class="job-offer-card__benefits-img" 
            src="/assets/iconos/house-grey.svg" 
          />
          <span>Full-time</span>
        `;
        break;
      case 'hybrid':
        benefitHTML = `
          <img 
            class="job-offer-card__benefits-img" 
            src="/assets/iconos/time-grey.svg" 
          />
          <span>Híbrido</span>
        `;
        break;
    }
    
    return `
      <div class="job-offer-card__benefits-items gap-1">
        ${benefitHTML}
      </div>`;
  }).join('');
};

const capitalizeText = (text) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

class JobOfferCard extends HTMLElement {
  connectedCallback() {
    if (
      DEVELOPMENT || (
      window["__PRERENDER_INJECTED"] && 
      window["__PRERENDER_INJECTED"].render_text)
    ) this.render();
  }

  render() {
    const positionData = this.getPositionData();
    this.innerHTML = getCard(positionData);
  }

  getPositionData() {
    return {
      benefits: JSON.parse(this.getAttribute('benefits')),
      cta: sanitizeString(this.getAttribute('cta')) || 'Ver oferta',
      description: sanitizeString(this.getAttribute('description')),
      experience: sanitizeString(this.getAttribute('experience')) || 'mid',
      slug: sanitizeString(this.getAttribute('slug')),
      title: sanitizeString(this.getAttribute('title')),
    };
  }
}

customElements.define('custom-job-offer-card', JobOfferCard);